import { useCallback as e, useRef as t, useState as n } from "react";
//#region src/hooks/useUncontrollable.ts
function r(r, i, a) {
	let o = t(r !== void 0), [s, c] = n(i), l = r !== void 0, u = o.current;
	return o.current = l, !l && u && s !== i && c(i), [l ? r : s, e((...e) => {
		let [t, ...n] = e, r = a?.(t, ...n);
		return c(t), r;
	}, [a])];
}
//#endregion
export { r as useUncontrolledProp };

//# sourceMappingURL=useUncontrollable.js.map